import { render, staticRenderFns } from "./DoctorAccountStatement.vue?vue&type=template&id=02af009c&scoped=true"
import script from "./DoctorAccountStatement.vue?vue&type=script&lang=js"
export * from "./DoctorAccountStatement.vue?vue&type=script&lang=js"
import style0 from "./DoctorAccountStatement.vue?vue&type=style&index=0&id=02af009c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02af009c",
  null
  
)

export default component.exports